import { render, staticRenderFns } from "./social-btns.vue?vue&type=template&id=5a86c3cb&scoped=true"
import script from "./social-btns.vue?vue&type=script&lang=js"
export * from "./social-btns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a86c3cb",
  null
  
)

export default component.exports